import { AxiosResponse } from "axios";
import { http } from "../../../utils";

export function fetchInvoicesPdf(
    finYear: string,
    isGst: boolean | null,
    from?: string,
    to?: string,
    siteId?: string,
    partyInvoices?: string,
    partyId?: string
) {
    const accountId = siteId ? siteId : '0'
    let url = `/interim_bill/pvt/invoices_pdf?account_id=${accountId}`
    if (isGst === true || isGst === false) {
        url = `${url}&isGst=${isGst}`
        url = `${url}&gst_type=${isGst ? 'ALL_GST' : 'NONE'}`
    }
    if(finYear != null) {
        url = `${url}&fin_year=${finYear}`
    }
    if(from) {
        url = `${url}&from=${from}`
    }
    if(to) {
        url = `${url}&to=${to}`
    }
    if(partyInvoices) {
        url = `${url}&party_invoices=${partyInvoices}`
    }
    if(partyId) {
        url = `${url}&party_id=${partyId}`
    }
    return http
        .get(
            url
        )
        .then((response: AxiosResponse) => response.data)
}

export interface AllInvoicesZipResponse {
  success: boolean
  message?: string
}

export function fetchAllInvoicesZip(
  finYear: string,
  isGst: boolean | null,
  from: string | undefined,
  to: string | undefined,
  siteId: string | undefined,
  partyInvoices: string | undefined,
  partyId: string | undefined,
  recipientEmail: string
) {
  let accountId = siteId ? siteId : '0'
  let url = `/interim_bill/pvt/all_invoices_zip?account_id=${accountId}`
  if (isGst === true || isGst === false) {
    url = `${url}&isGst=${isGst}`
    url = `${url}&gst_type=${isGst ? 'ALL_GST' : 'NONE'}`
  }
  if (finYear != null) {
    url = `${url}&fin_year=${finYear}`
  }
  if (from) {
    url = `${url}&from=${from}`
  }
  if (to) {
    url = `${url}&to=${to}`
  }
  if (partyInvoices) {
    url = `${url}&party_invoices=${partyInvoices}`
  }
  if (partyId) {
    url = `${url}&party_id=${partyId}`
  }
  url = `${url}&recipient_email=${encodeURIComponent(recipientEmail)}`
  return http
    .get(url)
    .then((response: AxiosResponse) => response.data as AllInvoicesZipResponse)
}

export function fetchInvoicesExcel(
    finYear: string,
    isGst: boolean | null,
    from?: string,
    to?: string,
    siteId?: string,
    partyInvoices?: string,
    partyId?: string
) {
    const accountId = siteId ? siteId : '0'
    let url = `/interim_bill/pvt/invoices_excel?account_id=${accountId}`
    if (isGst === true || isGst === false) {
        url = `${url}&isGst=${isGst}`
        url = `${url}&gst_type=${isGst ? 'ALL_GST' : 'NONE'}`
    }
    if(finYear != null) {
        url = `${url}&fin_year=${finYear}`
    }
    if(from) {
        url = `${url}&from=${from}`
    }
    if(to) {
        url = `${url}&to=${to}`
    }
    if(partyInvoices) {
        url = `${url}&party_invoices=${partyInvoices}`
    }
    if(partyId) {
        url = `${url}&party_id=${partyId}`
    }
    return http
        .get(
            url
        )
        .then((response: AxiosResponse) => response.data)
}

export type BulkInvoiceAction = 'SEND_EMAIL' | 'DELETE'

export interface BulkInvoiceActionRequest {
  invoiceIds: number[]
  action: BulkInvoiceAction
}

export interface BulkInvoiceActionResponse {
  success: boolean
  message?: string
  data?: {
    processedCount?: number
    failedCount?: number
    failedInvoiceIds?: number[]
  }
}

export function bulkInvoiceAction(request: BulkInvoiceActionRequest) {
  return http
    .post('/interim_bill/pvt/bulk_action', request)
    .then(
      (response: AxiosResponse) => response.data as BulkInvoiceActionResponse
    )
}